import { useQuery } from '@tanstack/react-query'
import { OPERATOR_HEARTBEAT_INTERVAL_MS } from '@groupe-reca/contracts'
import { useOperator } from './OperatorServices'

export const operationKeys = {
  offers: (userId: string) => ['offers', userId] as const,
  help: (userId: string) => ['help', userId] as const,
}

/** Offres de renfort visibles par l'opérateur, relues toutes les 30 s (aucun temps réel). */
export function useReinforcementOffers() {
  const { userId, repository } = useOperator()
  return useQuery({
    queryKey: operationKeys.offers(userId),
    queryFn: () => repository.reinforcementOffers(),
    refetchInterval: OPERATOR_HEARTBEAT_INTERVAL_MS,
  })
}

/** Demandes d'aide de l'opérateur (ouvertes, ou résolues depuis moins de 12 h). */
export function useHelpRequests() {
  const { userId, repository } = useOperator()
  return useQuery({
    queryKey: operationKeys.help(userId),
    queryFn: () => repository.helpRequests(),
    refetchInterval: OPERATOR_HEARTBEAT_INTERVAL_MS,
  })
}
